module.exports = __webpack_public_path__ + "img/skridsko_iskant.44c26965.jpg";